<template>
  <div class="ci-root">

    <div class="ci-header">
      <i class="el-icon-user ci-header-icon" />
      <span class="ci-header-title">客户详情</span>
    </div>

    <el-form :model="form" ref="from" :rules="rules" label-position="top" size="small">

      <div class="ci-form-grid">

        <!-- 客户微信号 -->
        <el-form-item label="客户微信号" prop="ClientWechat" class="ci-item--wide">
          <el-input :disabled="!wechatedit" v-model="form.ClientWechat" placeholder="请输入微信号" />
        </el-form-item>

        <!-- 手机号 -->
        <el-form-item label="手机号" prop="PhoneNumber">
          <el-input v-model="form.PhoneNumber" placeholder="请输入手机号" />
        </el-form-item>

        <!-- 客户来源 -->
        <el-form-item label="客户来源" prop="FromWhere">
          <el-select v-model="form.FromWhere" style="width:100%" placeholder="请选择来源">
            <el-option v-for="item in fromWhereArray" :key="item" :value="item" :label="item" />
          </el-select>
        </el-form-item>

        <!-- 推荐人（仅转介绍时显示） -->
        <el-form-item v-if="form.FromWhere === '转介绍'" label="推荐人" class="ci-item--wide">
          <el-select
            v-model="form.Referrer"
            filterable remote value-key="ID" reserve-keyword
            placeholder="请输入关键词搜索客户"
            style="width:100%"
            @focus="getClientsOptions('')"
            :remote-method="getClientsOptions"
            :loading="optionsloading"
          >
            <el-option
              v-for="item in clientOptions"
              :key="item.ID"
              :label="item.Client.ClientWechat"
              :value="item"
            />
            <div slot="empty" class="ci-empty">未找到客户</div>
          </el-select>
        </el-form-item>

        <!-- 业务号 -->
        <el-form-item label="业务微信号" prop="SellerWechat">
          <el-select
            v-model="form.SellerWechat"
            filterable remote reserve-keyword
            placeholder="请输入关键词"
            style="width:100%"
            @focus="getSellerOptions('')"
            :remote-method="getSellerOptions"
            :loading="optionsloading"
          >
            <el-option
              v-for="item in sellerOptions"
              :key="item.ID"
              :label="item.SellerWechat"
              :value="item.SellerWechat"
            />
          </el-select>
        </el-form-item>

        <!-- 客户类型 -->
        <el-form-item label="客户类型" prop="ClientType">
          <el-select v-model="form.ClientType" style="width:100%" placeholder="请选择类型">
            <el-option v-for="item in clientTypeArray" :key="item" :value="item" :label="item" />
          </el-select>
        </el-form-item>

        <!-- 学校 -->
        <el-form-item label="学校" prop="ClientSchool" class="ci-item--wide">
          <el-select
            v-model="form.ClientSchool"
            filterable
            placeholder="请输入学校名称"
            style="width:100%"
            @focus="getschool"
            :loading="optionsloading"
          >
            <el-option
              v-for="item in schoollist"
              :key="item.ID"
              :label="item.SchoolName"
              :value="item.SchoolName"
            />
          </el-select>
        </el-form-item>

        <!-- 学历 -->
        <el-form-item label="学历" prop="Level">
          <el-select v-model="form.Level" style="width:100%" placeholder="请选择学历">
            <el-option label="Undergraduate" value="Undergraduate" />
            <el-option label="Master"        value="Master" />
            <el-option label="PHD"           value="PHD" />
          </el-select>
        </el-form-item>

      </div>

      <!-- 选课列表 -->
      <div v-if="form.ClientSchool" class="ci-course-section">
        <div class="ci-section-label">选课列表</div>
        <course-list :list="form.CourseList" :SchoolName="form.ClientSchool" :editable="true" />
      </div>

    </el-form>

    <div class="ci-footer">
      <button type="button" class="ci-btn ci-btn--submit" @click="newclientdetail">
        <i class="el-icon-check" /> 提交
      </button>
    </div>

  </div>
</template>

<script>
import CourseList from '../CourseList/index.vue'
import GradeList  from '@/views/writer/components/gradelist/index.vue'

export default {
  name: 'ClientDetailInputer',
  components: { GradeList, CourseList },

  props: {
    fromtype:        { type: String, default: 'seller' },
    wechat:          { default: '' },
    wechatedit:      { default: true },
    form: {
      default: () => ({
        ClientWechat: '', PhoneNumber: '', ClientType: '',
        ClientSchool: '', Level: '', FromWhere: '',
        Referrer: {}, Tag: '', Remark: '', ClientDetail: '',
        CourseList: [], SellerWechat: ''
      })
    },
    fromWhereArray: {
      type: Array,
      default: () => ['微信', '转介绍', '小红书', '淘宝']
    },
    clientTypeArray: {
      type: Array,
      default: () => ['student', 'Agents']
    }
  },

  data() {
    return {
      clientOptions:  [],
      sellerOptions:  [],
      optionsloading: false,
      schoollist:     [],
      rules: {
        SellerWechat:  [{ required: true, message: '请输入业务号',    trigger: 'blur' }],
        FromWhere:     [{ required: true, message: '请选择客户来源',  trigger: 'change' }],
        ClientWechat:  [{ required: true, message: '请输入微信号',    trigger: 'blur' }],
        PhoneNumber:   [{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }],
        Level:         [{ required: true, message: '请选择学历',      trigger: 'change' }],
        ClientSchool:  [{ required: true, message: '请选择学校',      trigger: 'change' }],
        ClientType:    [{ required: true, message: '请选择客户类型',  trigger: 'change' }]
      }
    }
  },

  methods: {
    getClientsOptions(query) {
      this.optionsloading = true
      this.$store.dispatch('client/getmyclients', { searchstr: query, status: 'all' }).then(res => {
        this.clientOptions  = res.clients
        this.optionsloading = false
      })
    },
    getSellerOptions(query) {
      this.optionsloading = true
      this.$store.dispatch('order/getsellerwechat', { searchstr: query }).then(res => {
        this.sellerOptions  = res.data
        this.optionsloading = false
      })
    },
    getschool() {
      this.$store.dispatch('common/getschoolmajors').then(res => {
        this.schoollist = res.data.school
      })
    },
    newclientdetail() {
      this.$refs.from.validate(valid => {
        if (!valid) return
        this.form.InputType = this.fromtype
        this.$store.dispatch('client/newclientdetail', this.form).then(res => {
          if (res.code === 200) {
            this.$message({ message: res.msg, type: 'success' })
            this.$emit('success', res.ClientDetail)
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.ci-root {
  padding: 4px 0;
}

/* 头部 */
.ci-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 0.5px solid rgba(0,0,0,0.07);
}
.ci-header-icon  { font-size: 16px; color: #378ADD; flex-shrink: 0; }
.ci-header-title { font-size: 15px; font-weight: 500; color: #1a1a1a; }

/* 表单 label */
.ci-root >>> .el-form-item__label {
  font-size: 12px;
  font-weight: 500;
  color: #888;

}

/* 输入框统一圆角 */
.ci-root >>> .el-input__inner,
.ci-root >>> .el-textarea__inner {
  border-radius: 6px;
  border: 0.5px solid #dcdfe6;
  font-size: 12px;
  height: 32px;
  line-height: 32px;
}
.ci-root >>> .el-input__inner:focus,
.ci-root >>> .el-textarea__inner:focus {
  border-color: #409EFF;
}
.ci-root >>> .el-input.is-disabled .el-input__inner {
  background: #f7f8fa;
  color: #bbb;
}

/* 两列网格 */
.ci-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 20px;
}
.ci-item--wide {
  grid-column: 1 / -1;
}

/* 空状态 */
.ci-empty {
  padding: 12px;
  text-align: center;
  font-size: 12px;
  color: #bbb;
}

/* 选课列表区块 */
.ci-course-section {
  margin-top: 4px;
  padding: 12px;
  background: #fafafa;
  border: 0.5px solid rgba(0,0,0,0.07);
  border-radius: 8px;
}
.ci-section-label {
  font-size: 12px;
  font-weight: 500;
  color: #888;
  margin-bottom: 10px;
}

/* 底部 */
.ci-footer {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  margin-top: 8px;
  border-top: 0.5px solid rgba(0,0,0,0.07);
}

.ci-btn {
  height: 32px;
  padding: 0 20px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-family: inherit;
  transition: background 0.12s;
}
.ci-btn--submit {
  background: #1a1a1a;
  color: #fff;
}
.ci-btn--submit:hover { background: #333; }

/* 手机适配 */
@media (max-width: 600px) {
  .ci-form-grid {
    grid-template-columns: 1fr;
  }
  .ci-item--wide {
    grid-column: 1;
  }
}
</style>